export default {
      id: "send_sms-usage",
      viewBox: "0 0 11 10",
      url: __webpack_public_path__ + "img/icons.svg#send_sms",
      toString: function () {
        return this.url;
      }
    }